
export const findParent = (tag, check,{reject=undefined}={}) => {
    const parentNode = tag.parentNode;
    if (reject?.(parentNode)) {
        return null;
    }
    // console.log("parentNode", parentNode);
    if (!parentNode) {
        return null;
    }
    if (check(parentNode)) {
        return parentNode;
    }
    return findParent(parentNode, check, {reject});
};
